// extracted by css-extract-rspack-plugin
export default {"section":"Section-module__section__jsve4","withBorder":"Section-module__withBorder__HoSjy","intro":"Section-module__intro__qZ9JI"};